<div class="block--content block" id="main-content">
    <ridango-page-content-wrapper>
        <rwidget-alert></rwidget-alert>

        <div class="ticket">
            <rwidget-related-card-personalize-aside></rwidget-related-card-personalize-aside>
            <rwidget-related-card-personalize></rwidget-related-card-personalize>
        </div>
    </ridango-page-content-wrapper>
</div>
